export enum NoteSubjectTypeEnum {
    CORPO = "CORPO",
    RETAIL = "RETAIL",
}